export const SITE = {
  name: "JIF – Jack Iannotti Flowers",
  shortName: "JIF Flowers",
  phone: "(401) 822-4440",
  phoneHref: "tel:+14018224440",
  address: "1117 Main Street, Coventry, RI 02816",
  addressShort: "1117 Main Street, Coventry",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=1117+Main+Street,+Coventry,+RI+02816",
  founded: "1974",
  facebook: "https://facebook.com/jackiannotti.flowers",
  area: "Coventry, RI and the Kent County area",
  logoAlt: "JIF – Jack Iannotti Flowers, Coventry, RI",
};

export const HOURS = [
  { days: "Monday – Friday", time: "9:00 a.m. – 4:00 p.m." },
  { days: "Saturday", time: "9:00 a.m. – 2:00 p.m." },
  { days: "Sunday", time: "Closed" },
  { days: "Holiday weeks", time: "Open later — call ahead" },
];

export const MAIN_NAV = [
  { label: "Flowers", href: "/occasions", testid: "nav-flowers" },
  { label: "Sympathy", href: "/sympathy-funeral-flowers", testid: "nav-sympathy" },
  { label: "Holidays & Events", href: "/seasonal", testid: "nav-seasonal" },
  { label: "Plants & Gifts", href: "/plants-gifts", testid: "nav-plants" },
  { label: "About Us", href: "/about", testid: "nav-about" },
  { label: "Contact", href: "/contact", testid: "nav-contact" },
];

export const MARQUEE_ITEMS = [
  "Family Owned Since 1974",
  "Designed In-Shop on Main Street",
  "Hand-Delivered, Always Confirmed",
  "Sympathy Tributes",
  "Seasonal & Holiday Flowers",
  "Fresh From Our Own Cooler",
  "Coventry · Kent County, RI",
];

export const OCCASIONS = [
  {
    path: "/occasions/birthday-flowers",
    slug: "birthday-flowers",
    name: "Birthday Flowers",
    seoTitle: "Birthday Flower Delivery Coventry RI | JIF Flowers",
    seoDescription:
      "Birthday flowers designed in our Coventry, RI shop and hand-delivered the same day in most cases. Call JIF Flowers at (401) 822-4440 to order.",
    eyebrow: "Occasions",
    title: ["Birthday Flowers,", "Made to Make Their Day"],
    lede: "Bright, fresh birthday arrangements designed in our Coventry shop and hand-delivered across the Kent County area.",
    image: "https://images.unsplash.com/photo-1606101083393-bded314215cd?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Bright birthday flower arrangement with mixed seasonal blooms",
    introTitle: "A birthday bouquet that didn't come in a box",
    paragraphs: [
      "A birthday bouquet from JIF starts in our own cooler, not a warehouse. Our designers build each arrangement in the shop on Main Street the day it goes out, using the freshest stems we have — so the flowers arrive at their peak and last well beyond the party.",
      "Tell us who you're celebrating and what they love. Cheerful sunflowers and gerbera daisies, classic roses, or a loose garden-style mix in their favorite colors — we design to the person, at any budget, from a single elegant stem to a showpiece for the table.",
    ],
    bulletsTitle: "Why Coventry calls JIF for birthdays",
    bullets: [
      "Same-day delivery in most cases when you order before 3:00 p.m.",
      "Every arrangement designed in-shop, never shipped in a box",
      "Hand-delivered by our own driver, and every delivery confirmed",
      "Any size, any budget — from a single stem to a grand gesture",
    ],
    closingTitle: "Order birthday flowers by phone",
    closing:
      "Call the shop and tell us about the birthday. We'll suggest what's freshest and most beautiful that day, take your card message, and handle the rest.",
  },
  {
    path: "/occasions/anniversary-romance-flowers",
    slug: "anniversary-romance-flowers",
    name: "Anniversary & Romance",
    seoTitle: "Anniversary Flowers Coventry RI | JIF Flowers",
    seoDescription:
      "Anniversary and romance flowers, from classic long-stem roses to garden-style bouquets, hand-delivered in Coventry & Kent County. Call (401) 822-4440.",
    eyebrow: "Occasions",
    title: ["Anniversary & Romance,", "Said With Fresh Flowers"],
    lede: "Long-stem roses, lush garden bouquets, and arrangements built around your story — designed in Coventry and hand-delivered with care.",
    image: "https://images.unsplash.com/photo-1558879787-4c4aea1fbb83?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Romantic rose bouquet for an anniversary",
    introTitle: "Fifty years or the first one — we'll help you say it",
    paragraphs: [
      "Some anniversaries call for a dozen perfect long-stem roses. Others call for the flowers she carried down the aisle. Because we're a real flower shop with a full cooler — not a national order website — we can build the arrangement that actually means something.",
      "Share a detail or two when you call: her favorite flower, her favorite color, the year you married. Our designers love those details, and they show in the finished piece.",
    ],
    bulletsTitle: "Romance, the JIF way",
    bullets: [
      "Premium long-stem roses, cut fresh from our cooler",
      "Unusual varieties available — just ask what's in season",
      "Hand-delivered to homes, workplaces, and restaurants",
      "Add a handwritten card with your own words",
    ],
    closingTitle: "Plan something she'll remember",
    closing:
      "Call us a day or two ahead for something custom, or the same morning before 3:00 p.m. for same-day delivery in most cases.",
  },
  {
    path: "/occasions/new-baby-flowers",
    slug: "new-baby-flowers",
    name: "New Baby Flowers",
    seoTitle: "New Baby Flowers Rhode Island | JIF Flowers Coventry",
    seoDescription:
      "Welcome a new baby with fresh flowers delivered to the hospital or home across Kent County, RI. Family florist since 1974. Call (401) 822-4440.",
    eyebrow: "Occasions",
    title: ["New Baby Flowers,", "For the Sweetest Hello"],
    lede: "Soft, joyful arrangements to welcome the newest arrival — delivered to the hospital or the family's front door.",
    image: "https://images.pexels.com/photos/31046060/pexels-photo-31046060.jpeg?auto=compress&cs=tinysrgb&w=1000",
    imageAlt: "Soft pastel bouquet celebrating a new baby",
    introTitle: "Welcome them with something fresh and gentle",
    paragraphs: [
      "A new baby deserves flowers as fresh as the occasion. We design soft pastel bouquets, cheerful yellows, and classic pinks and blues — always with gentle, lightly scented varieties that are kind to a nursery.",
      "Delivering to the hospital? We deliver to Kent Hospital in Warwick and area facilities regularly, and we confirm every delivery. Sending to the house instead? Our driver will hand them over with a smile.",
    ],
    bulletsTitle: "Good to know for new baby flowers",
    bullets: [
      "Lightly scented, nursery-friendly varieties available",
      "Delivery to Kent Hospital and area nursing facilities",
      "Add a plush keepsake or mylar balloon when you call",
      "Same-day delivery in most cases before 3:00 p.m.",
    ],
    closingTitle: "Send your congratulations today",
    closing:
      "Call the shop with the family's name and where to find them. We'll design something lovely and make sure it arrives.",
  },
  {
    path: "/occasions/get-well-flowers",
    slug: "get-well-flowers",
    name: "Get Well Flowers",
    seoTitle: "Get Well Flowers Coventry RI | JIF Flowers Delivery",
    seoDescription:
      "Cheerful get-well flowers and plants delivered to Kent Hospital, nursing homes, and homes across Kent County, RI. Call (401) 822-4440.",
    eyebrow: "Occasions",
    title: ["Get Well Flowers,", "A Little Sunshine, Delivered"],
    lede: "Bright, cheering arrangements and easy-care plants for hospital rooms, rehab stays, and recoveries at home.",
    image: "https://images.unsplash.com/photo-1558879860-45f24b366ea1?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Cheerful get-well bouquet in bright seasonal colors",
    introTitle: "Send a little sunshine to someone on the mend",
    paragraphs: [
      "When someone you love is recovering, a bright bouquet does real work. We design get-well arrangements in cheerful yellows, oranges, and garden mixes that lift a room — and we know the delivery routines at Kent Hospital and the area's nursing and rehab facilities.",
      "For longer recoveries, consider a blooming plant or dish garden. They last for weeks, need little care, and give the patient something living to tend as they heal.",
    ],
    bulletsTitle: "Sending get-well flowers with JIF",
    bullets: [
      "We know Kent Hospital's delivery procedures and floor routines",
      "Lightly scented options for sensitive patients",
      "Blooming plants and dish gardens for lasting cheer",
      "Every delivery hand-carried and confirmed",
    ],
    closingTitle: "Brighten someone's recovery",
    closing:
      "Call with the patient's name and room or facility, and we'll take it from there — usually the same day before 3:00 p.m.",
  },
  {
    path: "/occasions/thank-you-flowers",
    slug: "thank-you-flowers",
    name: "Thank You & Just Because",
    seoTitle: "Thank You Flower Delivery RI | JIF Flowers Coventry",
    seoDescription:
      "Say thank you — or just because — with fresh flowers hand-delivered across Kent County, RI. Family florist in Coventry since 1974. (401) 822-4440.",
    eyebrow: "Occasions",
    title: ["Thank You & Just Because,", "The Best Reasons of All"],
    lede: "For the neighbor who helped, the teacher who stayed late, or no reason at all — fresh flowers say it best.",
    image: "https://images.pexels.com/photos/5414032/pexels-photo-5414032.jpeg?auto=compress&cs=tinysrgb&w=1000",
    imageAlt: "Fresh mixed bouquet to say thank you",
    introTitle: "No occasion required",
    paragraphs: [
      "Some of our favorite orders start with \u201cI just want to make her smile.\u201d A simple bouquet from our walk-in cooler — garden roses, tulips in spring, sunflowers in summer — delivered the same afternoon, does exactly that.",
      "Because we stock ready-to-go arrangements, roses, and mixed bouquets in the shop, a thoughtful thank-you is never more than a phone call away. Stop in and pick one out, or call and let us choose the prettiest thing in the cooler.",
    ],
    bulletsTitle: "Everyday kindness, made easy",
    bullets: [
      "Ready-to-go bouquets in our walk-in cooler every day",
      "Any budget genuinely works — tell us a number",
      "Same-day delivery in most cases before 3:00 p.m.",
      "Handwritten card included with every order",
    ],
    closingTitle: "Make someone's ordinary day",
    closing: "Call the shop or stop by Main Street. The cooler is full, and gratitude never needs an appointment.",
  },
];

export const HOLIDAYS = [
  {
    path: "/valentines-day-flowers",
    slug: "valentines-day-flowers",
    name: "Valentine's Day Flowers",
    seoTitle: "Valentine's Roses Coventry RI | JIF Flowers",
    seoDescription:
      "Premium Valentine's Day roses and romantic bouquets, hand-delivered in Coventry & Kent County. Order early by phone: (401) 822-4440.",
    eyebrow: "Holidays & Seasonal",
    title: ["Valentine's Day,", "Done Beautifully"],
    lede: "Premium long-stem roses and romantic designs from Coventry's family florist — order early, we hand-deliver across Kent County.",
    image: "/images/holiday-valentines.webp",
    imageAlt: "Red roses arranged for Valentine's Day",
    introTitle: "Roses worth the occasion",
    paragraphs: [
      "Valentine's week is the busiest of our year, and we prepare for it the old-fashioned way: cooler stocked deep with premium roses, extra hands at the design bench, and our van running deliveries all day. Nothing we send is boxed or shipped — every Valentine leaves our shop in the hands of our own driver.",
      "Classic red dozen, a lush mixed romance bouquet, or something unusual like garden roses or ranunculus — call early for the best selection. Valentine's flowers are our most requested of the year, and the cooler does empty.",
    ],
    bulletsTitle: "Valentine's ordering with JIF",
    bullets: [
      "Premium long-stem roses, conditioned in our own cooler",
      "Order early by phone — we do not take online orders",
      "Hand-delivered to homes, offices, and schools",
      "100% satisfaction guarantee on every arrangement",
    ],
    closingTitle: "Reserve your Valentine's flowers",
    closing:
      "Call (401) 822-4440 to place your Valentine's order. A few days early is always wise — we'll take care of everything else.",
  },
  {
    path: "/mothers-day-flowers",
    slug: "mothers-day-flowers",
    name: "Mother's Day Flowers",
    seoTitle: "Mother's Day Flowers Coventry RI | JIF Flowers",
    seoDescription:
      "Mother's Day bouquets and plants hand-delivered in Coventry and Kent County, RI. Family florist since 1974. Call to order: (401) 822-4440.",
    eyebrow: "Holidays & Seasonal",
    title: ["Mother's Day,", "From a Family That Gets It"],
    lede: "Lush spring bouquets, garden roses, and blooming plants for Mom — designed in our Coventry shop and hand-delivered with love.",
    image: "/images/holiday-mothers-day.webp",
    imageAlt: "Spring bouquet of soft pink flowers for Mother's Day",
    introTitle: "She deserves better than a box on the doorstep",
    paragraphs: [
      "We're a family shop, so Mother's Day means something here. Our designers fill the week with peonies when we can get them, garden roses, tulips, hydrangea, and fragrant lilies — the flowers Rhode Island mothers actually love, arranged by hand and delivered by our own driver.",
      "A blooming plant or hanging basket is a beautiful alternative that lasts all season. Stop in the week before and choose from the cooler, or call and let us design something in her favorite colors.",
    ],
    bulletsTitle: "Mother's Day at the shop",
    bullets: [
      "Peak-season spring flowers at their freshest",
      "Blooming plants and baskets that last for months",
      "Delivery across Coventry and the Kent County area",
      "Order by phone early — the holiday week fills fast",
    ],
    closingTitle: "Order Mom's flowers by phone",
    closing:
      "Call (401) 822-4440 to order for Mother's Day. Tell us about your mom — favorite flower, favorite color — and we'll take it personally.",
  },
  {
    path: "/thanksgiving-flowers",
    slug: "thanksgiving-flowers",
    name: "Fall & Thanksgiving Flowers",
    seoTitle: "Thanksgiving Centerpieces Coventry RI | JIF Flowers",
    seoDescription:
      "Fall centerpieces and Thanksgiving flowers designed in Coventry, RI and hand-delivered across Kent County. Call JIF Flowers: (401) 822-4440.",
    eyebrow: "Holidays & Seasonal",
    title: ["Fall & Thanksgiving,", "Gathered From the Season"],
    lede: "Harvest centerpieces, autumn bouquets, and warm seasonal designs for the table where everyone gathers.",
    image: "/images/holiday-thanksgiving.webp",
    imageAlt: "Autumn centerpiece with warm-toned seasonal flowers",
    introTitle: "The table deserves flowers too",
    paragraphs: [
      "Thanksgiving in Kent County means full tables and full houses. Our autumn centerpieces — rich oranges, deep reds, golden mums, textured pods, and berries — are built low and lush so conversation flows right over them.",
      "Hosting? Call a few days ahead and we'll design to your table's length and your china's colors. Guest? A centerpiece or autumn bouquet is the hostess gift that never gets put away in a cabinet.",
    ],
    bulletsTitle: "For the harvest table",
    bullets: [
      "Low, lush centerpieces sized to your table",
      "Cornucopias, candle designs, and modern autumn styles",
      "Fresh designs delivered the day before the holiday",
      "Any size — one table or fifty centerpieces",
    ],
    closingTitle: "Set a beautiful Thanksgiving table",
    closing:
      "Call the shop before the holiday rush and tell us about your table. We'll design something that makes the meal feel like an occasion.",
  },
  {
    path: "/christmas-flowers-poinsettias",
    slug: "christmas-flowers-poinsettias",
    name: "Christmas Flowers & Poinsettias",
    seoTitle: "Poinsettias & Christmas Flowers Coventry RI | JIF",
    seoDescription:
      "Christmas centerpieces, poinsettias, and holiday arrangements hand-delivered in Coventry & Kent County, RI. Call JIF Flowers: (401) 822-4440.",
    eyebrow: "Holidays & Seasonal",
    title: ["Christmas Flowers", "& Poinsettias"],
    lede: "Festive centerpieces, fresh poinsettias, and evergreen designs — the shop smells like Christmas from late November on.",
    image: "/images/holiday-christmas.webp",
    imageAlt: "Festive Christmas flower arrangement with seasonal greenery",
    introTitle: "Christmas, from a real Main Street flower shop",
    paragraphs: [
      "The holidays at JIF mean fresh balsam in the air, poinsettias in rows, and centerpieces with candles ready for Christmas dinner. Our poinsettias come in classic red, white, and pink — full, healthy plants that hold through the season with a little care.",
      "Sending holiday flowers across town? Our van runs daily through the Kent County area, and every gift is hand-delivered and confirmed. A centerpiece or poinsettia from a local shop lands differently than a shipped box — people notice.",
    ],
    bulletsTitle: "Holiday favorites at JIF",
    bullets: [
      "Poinsettias in red, white, and pink, in several sizes",
      "Candle centerpieces for Christmas dinner",
      "Evergreen and winter-white designs for the whole season",
      "Hand delivery to homes, offices, and churches",
    ],
    closingTitle: "Order your holiday flowers early",
    closing:
      "Call (401) 822-4440 to reserve poinsettias and centerpieces. The week before Christmas is our busiest — early calls get the best of the cooler.",
  },
];

export const TOWNS = [
  {
    path: "/flower-delivery/coventry-ri",
    slug: "coventry-ri",
    name: "Coventry",
    seoTitle: "Florist Coventry RI | JIF – Jack Iannotti Flowers",
    seoDescription:
      "Coventry's own family florist since 1974, on Main Street. Same-day flower delivery in most cases. Call JIF Flowers: (401) 822-4440.",
    eyebrow: "Flower Delivery",
    title: ["Flower Delivery", "in Coventry, RI"],
    lede: "Our hometown. The shop is right on Main Street, and our van knows every road in Coventry by heart.",
    introTitle: "Coventry's own flower shop since 1974",
    paragraphs: [
      "JIF has been part of Coventry for over fifty years — first days of school, anniversaries, and hard goodbyes. When you order from us, your flowers are designed a few minutes from your door, in our shop at 1117 Main Street, and delivered by a driver who knows the difference between Route 3 and Route 117 without a GPS.",
      "From Hopkins Hill to Washington, from the lake neighborhoods to the village, we deliver across all of Coventry — usually the same day when you call before 3:00 p.m.",
    ],
    bulletsTitle: "Coventry delivery, the details",
    bullets: [
      "Same-day delivery in most cases before 3:00 p.m.",
      "Every delivery hand-carried and confirmed",
      "Funeral homes, churches, schools, and businesses served",
      "Walk in to the shop anytime — the cooler is always full",
    ],
    closingTitle: "Order Coventry flower delivery",
    closing: "Call (401) 822-4440 or stop by the shop on Main Street. You're our neighbor — that's the whole point.",
  },
  {
    path: "/flower-delivery/west-warwick-ri",
    slug: "west-warwick-ri",
    name: "West Warwick",
    seoTitle: "Florist West Warwick RI | JIF Flowers Delivery",
    seoDescription:
      "Fresh flower delivery to West Warwick, RI from a family florist minutes away. Hand-delivered and confirmed. Call (401) 822-4440.",
    eyebrow: "Flower Delivery",
    title: ["Flower Delivery", "in West Warwick, RI"],
    lede: "Just up the road from our Coventry shop — West Warwick deliveries leave our cooler and arrive fresh, often the same day.",
    introTitle: "A real florist, minutes from West Warwick",
    paragraphs: [
      "West Warwick is next door to us, and we deliver there every day — homes along Providence Street, businesses near the mills, and celebrations throughout town. Because we're five minutes away, your flowers spend their time in our cooler, not in transit.",
      "Ordering is simple: call the shop, tell us the occasion and the address, and our driver hand-delivers and confirms every order.",
    ],
    bulletsTitle: "West Warwick delivery, the details",
    bullets: [
      "Same-day delivery in most cases before 3:00 p.m.",
      "Designed in Coventry, delivered fresh by our own van",
      "Sympathy deliveries coordinated with area funeral homes",
      "100% satisfaction guarantee on every order",
    ],
    closingTitle: "Order West Warwick flower delivery",
    closing: "Call (401) 822-4440 and we'll have something beautiful on its way to West Warwick today.",
  },
  {
    path: "/flower-delivery/warwick-ri",
    slug: "warwick-ri",
    name: "Warwick",
    seoTitle: "Florist Warwick RI | JIF Flowers, Coventry RI",
    seoDescription:
      "Flower delivery to Warwick, RI — including Kent Hospital — from JIF Flowers, a family florist in Coventry. Call (401) 822-4440.",
    eyebrow: "Flower Delivery",
    title: ["Flower Delivery", "in Warwick, RI"],
    lede: "From Apponaug to Cowesett, we deliver fresh, shop-designed flowers throughout Warwick — including Kent Hospital.",
    introTitle: "Fresh flowers to Warwick, hand-delivered",
    paragraphs: [
      "Warwick is one of our most frequent destinations. We deliver to homes and businesses across the city, and we know the routines at Kent Hospital well — room numbers, floor policies, and the right entrance — so get-well flowers arrive smoothly.",
      "Every arrangement is designed in our Coventry shop and driven over by our own driver. No relay services, no boxed flowers, no wondering whether it arrived — we confirm every delivery.",
    ],
    bulletsTitle: "Warwick delivery, the details",
    bullets: [
      "Regular deliveries to Kent Hospital and area facilities",
      "Same-day delivery in most cases before 3:00 p.m.",
      "Birthday, anniversary, sympathy, and everyday designs",
      "Family owned and operated since 1974",
    ],
    closingTitle: "Order Warwick flower delivery",
    closing: "Call (401) 822-4440 with your Warwick delivery, and we'll take care of the rest.",
  },
  {
    path: "/flower-delivery/east-greenwich-ri",
    slug: "east-greenwich-ri",
    name: "East Greenwich",
    seoTitle: "Florist East Greenwich RI | JIF Flowers",
    seoDescription:
      "Flower delivery to East Greenwich, RI from JIF Flowers of Coventry — boutique designs, hand-delivered and confirmed. Call (401) 822-4440.",
    eyebrow: "Flower Delivery",
    title: ["Flower Delivery", "in East Greenwich, RI"],
    lede: "Boutique florist designs delivered down Main Street and across East Greenwich — fresh from our Coventry cooler.",
    introTitle: "Boutique flowers, delivered to East Greenwich",
    paragraphs: [
      "East Greenwich has a taste for the beautiful, and so do we. Whether it's a dinner party on Main Street, a new baby at home, or a weekly arrangement for a Main Street business, our designers build pieces that suit the town's easy elegance.",
      "We deliver throughout East Greenwich regularly, and every order leaves our shop in the hands of our own driver — never a relay, never a box.",
    ],
    bulletsTitle: "East Greenwich delivery, the details",
    bullets: [
      "Same-day delivery in most cases before 3:00 p.m.",
      "Weekly standing arrangements for local businesses",
      "Sympathy flowers coordinated with area funeral homes",
      "Every delivery confirmed by our driver",
    ],
    closingTitle: "Order East Greenwich flower delivery",
    closing: "Call (401) 822-4440 to send something beautiful to East Greenwich today.",
  },
  {
    path: "/flower-delivery/west-greenwich-ri",
    slug: "west-greenwich-ri",
    name: "West Greenwich",
    seoTitle: "Florist West Greenwich RI | JIF Flowers Coventry",
    seoDescription:
      "Flower delivery to West Greenwich, RI from a family florist next door in Coventry. Same-day in most cases. Call (401) 822-4440.",
    eyebrow: "Flower Delivery",
    title: ["Flower Delivery", "in West Greenwich, RI"],
    lede: "Our quiet neighbor to the west — we deliver fresh flowers down West Greenwich's back roads every week.",
    introTitle: "Fresh flowers, even down the back roads",
    paragraphs: [
      "West Greenwich may be rural, but it's right next door to our Coventry shop, and our driver knows its roads well — from Route 102 to the neighborhoods off Victory Highway. Fresh flowers shouldn't be a city privilege.",
      "Birthdays, anniversaries, sympathy tributes, or a just-because bouquet — designed in our shop and hand-delivered the same day in most cases when you call before 3:00 p.m.",
    ],
    bulletsTitle: "West Greenwich delivery, the details",
    bullets: [
      "Reliable delivery to rural addresses",
      "Same-day delivery in most cases before 3:00 p.m.",
      "Sympathy flowers coordinated with area funeral homes",
      "Every delivery hand-carried and confirmed",
    ],
    closingTitle: "Order West Greenwich flower delivery",
    closing: "Call (401) 822-4440 — beautiful, fresh flowers are closer than you think.",
  },
];

export const SERVICE_PAGES = [
  {
    path: "/hospital-flower-delivery",
    slug: "hospital-flower-delivery",
    name: "Hospital & Nursing Home Delivery",
    seoTitle: "Flower Delivery Kent Hospital Warwick RI | JIF Flowers",
    seoDescription:
      "Get-well flowers delivered to Kent Hospital in Warwick and nursing homes across Kent County, RI. Hand-delivered, confirmed. (401) 822-4440.",
    eyebrow: "Flower Delivery",
    title: ["Hospital & Nursing Home", "Flower Delivery"],
    lede: "Cheerful, appropriate flowers delivered with care to Kent Hospital and care facilities across the Kent County area.",
    image: "https://images.unsplash.com/photo-1674784708710-0f03d1868ed3?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Soft white arrangement suitable for hospital delivery",
    introTitle: "We know the way to Kent Hospital",
    paragraphs: [
      "Hospital deliveries have their own etiquette — ward rules, fragrance sensitivities, room numbers that change. We've delivered to Kent Hospital in Warwick and the area's nursing and rehabilitation facilities for decades, so the process is smooth for you and for the staff.",
      "We'll help you choose something appropriate: bright and cheerful, lightly scented, in a container that fits a bedside table. If the patient has been discharged or moved, we confirm before we leave the shop.",
    ],
    bulletsTitle: "Hospital delivery, handled properly",
    bullets: [
      "Regular deliveries to Kent Hospital, Warwick",
      "Nursing homes and rehab facilities across Kent County",
      "Lightly scented, bedside-friendly designs",
      "Delivery confirmed — every single time",
    ],
    closingTitle: "Send flowers to a patient today",
    closing:
      "Call (401) 822-4440 with the patient's name and facility. We'll handle the details and make sure your flowers arrive.",
  },
  {
    path: "/prom-corsages-boutonnieres",
    slug: "prom-corsages-boutonnieres",
    name: "Prom Corsages & Boutonnieres",
    seoTitle: "Prom Corsages & Boutonnieres Coventry RI | JIF",
    seoDescription:
      "Custom prom corsages and boutonnieres designed at JIF Flowers in Coventry, RI. Match your dress and colors. Call (401) 822-4440.",
    eyebrow: "Prom Season",
    title: ["Prom Corsages", "& Boutonnieres"],
    lede: "Custom corsages and boutonnieres designed to match the dress, the suit, and the moment — made fresh in our Coventry shop.",
    image: "https://images.unsplash.com/photo-1574871786514-46e1680ea587?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Elegant floral corsage and boutonniere for prom",
    introTitle: "Prom flowers that actually match",
    paragraphs: [
      "Bring us the dress color — or better, a photo — and we'll design a corsage that belongs with it. Wrist corsages with keepsake bracelets, classic pin-on styles, and boutonnieres that hold up through photos, dinner, and the last dance.",
      "Prom season books up fast at every Kent County school. Call at least a week ahead so we can order exactly the right blooms in exactly your colors.",
    ],
    bulletsTitle: "Prom at JIF",
    bullets: [
      "Custom colors matched to dress and suit",
      "Wrist corsages with keepsake bracelets",
      "Boutonnieres built to last the whole night",
      "Order at least a week ahead for best selection",
    ],
    closingTitle: "Order prom flowers early",
    closing:
      "Call (401) 822-4440 or stop by the shop with a photo of the dress. We'll design something she'll want to keep.",
  },
  {
    path: "/business-flowers",
    slug: "business-flowers",
    name: "Business & Standing Orders",
    seoTitle: "Weekly Business Flowers Kent County RI | JIF",
    seoDescription:
      "Standing weekly flower arrangements for offices, restaurants, and shops across Kent County, RI. Fresh designs from JIF Flowers. (401) 822-4440.",
    eyebrow: "For Business",
    title: ["Business Flowers", "& Standing Orders"],
    lede: "Fresh weekly arrangements for offices, restaurants, and shops — delivered on schedule, refreshed without you thinking about it.",
    image: "https://images.pexels.com/photos/34041965/pexels-photo-34041965.jpeg?auto=compress&cs=tinysrgb&w=1000",
    imageAlt: "Fresh floral arrangement in a business reception area",
    introTitle: "A fresh welcome, every single week",
    paragraphs: [
      "A beautiful arrangement at the front desk or host stand changes how a business feels. Our standing-order clients — offices, restaurants, salons, and professional practices across Kent County — receive a fresh, seasonally changing design on a schedule that suits them.",
      "We design to your space, your brand colors, and your budget, then swap each arrangement on delivery day so your flowers are always fresh. One phone call sets it up; we handle everything after that.",
    ],
    bulletsTitle: "Standing orders with JIF",
    bullets: [
      "Weekly or biweekly delivery on your schedule",
      "Designs tailored to your space and colors",
      "Seasonal variety — never the same arrangement twice",
      "Any budget — scaled from desk vase to lobby centerpiece",
    ],
    closingTitle: "Set up flowers for your business",
    closing:
      "Call (401) 822-4440 and tell us about your space. We'll suggest a plan and deliver the first arrangement this week.",
  },
  {
    path: "/plants-gifts",
    slug: "plants-gifts",
    name: "Plants & Gifts",
    seoTitle: "Plants & Gift Baskets Coventry RI | JIF Flowers",
    seoDescription:
      "Green and blooming plants, dish gardens, and gift baskets in Coventry, RI — hand-delivered across Kent County. Call JIF: (401) 822-4440.",
    eyebrow: "The Shop",
    title: ["Plants & Gifts,", "For Lasting Sentiments"],
    lede: "Green plants, blooming baskets, and dish gardens that keep growing long after the occasion — hand-delivered across Kent County.",
    image: "/images/plants-gifts.webp",
    imageAlt: "Lush green and blooming plants at the flower shop",
    introTitle: "Gifts that keep growing",
    paragraphs: [
      "Some sentiments call for something that lasts. Our shop keeps a changing selection of green plants, blooming plants, dish gardens, and seasonal baskets — each one a gift that lives on a windowsill for months or years, not days.",
      "Plants are our most requested choice for sympathy gifts to the home, get-well wishes, and housewarmings. Every plant leaves the shop healthy and well-watered, hand-delivered by our own driver.",
    ],
    bulletsTitle: "In the shop now",
    bullets: [
      "Easy-care green plants in decorative containers",
      "Blooming plants — orchids, azaleas, seasonal favorites",
      "European dish gardens for sympathy and home",
      "Seasonal gift baskets — ask what's fresh",
    ],
    closingTitle: "Choose a lasting gift",
    closing:
      "Call (401) 822-4440 or stop by the shop on Main Street. We'll help you pick the right plant and deliver it the same day in most cases.",
  },
];

export const JOURNAL_POSTS = [
  {
    path: "/journal/funeral-flower-etiquette-guide",
    slug: "funeral-flower-etiquette-guide",
    title: "Funeral Flower Etiquette: A Simple Guide for Coventry Families",
    seoTitle: "Funeral Flower Etiquette Guide | JIF Flowers Coventry RI",
    seoDescription:
      "What to send, when to send it, and what the card should say — a plain-spoken guide to funeral flowers from Coventry's family florist.",
    date: "2026-06-18",
    dateLabel: "June 18, 2026",
    image: "https://images.unsplash.com/photo-1724152312974-d4d48b8b36fd?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "White lily sympathy arrangement",
    excerpt:
      "What to send, when to send it, and what to write on the card — plain answers from fifty years of helping local families.",
    body: [
      "After fifty years of working with Coventry's funeral homes, we've learned that most people have the same quiet questions. Here are plain answers.",
      "What should I send? Family members typically send the larger tributes — casket sprays, standing sprays, and wreaths. Friends, neighbors, and coworkers usually send vase arrangements, basket designs, or plants. There is no wrong choice; a simple, beautiful bouquet is always appropriate.",
      "When should it arrive? Flowers for the service should be delivered to the funeral home before the first visiting hours. When you order from us, we coordinate directly with the funeral home on timing — you don't need to manage that. Sending to the family's home instead is a kind choice too, especially in the weeks after the service, when the house grows quiet.",
      "What should the card say? Short and sincere is best. \u201cWith deepest sympathy,\u201d the person's name, and a warm memory if you have one. We hand-write every card, and we're glad to help you find the words when you call.",
      "One last thought: if the family has asked for donations \u201cin lieu of flowers,\u201d honor that wish — and consider sending flowers to the home a week or two later, when support is scarcest and most needed.",
    ],
  },
  {
    path: "/journal/make-cut-flowers-last-longer",
    slug: "make-cut-flowers-last-longer",
    title: "How to Make Fresh Cut Flowers Last Longer",
    seoTitle: "How to Make Cut Flowers Last Longer | JIF Flowers",
    seoDescription:
      "Simple, proven care tips from our Coventry flower shop to keep your fresh bouquet beautiful for a week or more.",
    date: "2026-05-27",
    dateLabel: "May 27, 2026",
    image: "https://images.unsplash.com/photo-1558879860-45f24b366ea1?crop=entropy&cs=srgb&fm=jpg&q=85",
    imageAlt: "Fresh bouquet in a vase with clean water",
    excerpt:
      "Fresh flowers from a shop cooler already have a head start. Here's how to keep them beautiful for a week or more.",
    body: [
      "Flowers from a real flower shop start fresher than anything shipped in a box — ours come straight from our cooler and local growers. With a little care at home, most arrangements will look beautiful for a week, often longer.",
      "Start with a clean vase. Bacteria is the enemy of cut flowers, so wash the vase with soap and hot water before filling it. Use the packet of flower food we include — it feeds the stems and keeps the water clean.",
      "Give stems a fresh cut every two or three days, at an angle, under running water if you can. Remove any leaves that sit below the waterline; submerged leaves rot quickly and foul the water.",
      "Keep the arrangement away from direct sun, radiators, and ripening fruit — fruit releases ethylene gas that ages flowers fast. A cool spot with indirect light is ideal.",
      "Top off the water daily; fresh flowers drink more than you'd expect. And when one stem fades, pluck it out — the rest will carry on beautifully. If anything disappoints you, call us. Every arrangement we sell carries our 100% satisfaction guarantee.",
    ],
  },
];

export const FAQS = [
  {
    q: "How do I place an order?",
    a: "By phone at (401) 822-4440 or in person at our shop at 1117 Main Street, Coventry. We take orders by phone or in person only — we don't offer online ordering, because we'd rather talk with you and get the details right.",
  },
  {
    q: "Do you offer same-day delivery?",
    a: "In most cases, yes — place your order before 3:00 p.m. and we can usually deliver the same day throughout our delivery area. Every delivery is hand-delivered by our own driver and confirmed.",
  },
  {
    q: "Where do you deliver?",
    a: "We deliver throughout Coventry, RI and the Kent County area, including West Warwick, Warwick, East Greenwich, and West Greenwich — homes, businesses, hospitals, funeral homes, churches, and event venues.",
  },
  {
    q: "Do you deliver to Kent Hospital and nursing homes?",
    a: "Yes. We deliver regularly to Kent Hospital in Warwick and to nursing and rehabilitation facilities across the area. We're familiar with their delivery procedures, and we confirm every delivery.",
  },
  {
    q: "How quickly can you handle funeral flowers?",
    a: "Sympathy orders are always our first priority. Call us as soon as you know the service details — we coordinate directly with the funeral home so your tribute arrives on time and exactly as ordered.",
  },
  {
    q: "Can you work within my budget?",
    a: "Yes — genuinely any budget. We design everything from a single elegant stem to fifty centerpieces, and we'll always tell you honestly what your budget can do beautifully.",
  },
  {
    q: "Do you work with funeral homes?",
    a: "Yes, directly and constantly. We coordinate with area funeral homes so sympathy tributes arrive on time and exactly as ordered. If you need funeral flowers quickly, call us and we'll take care of the timing.",
  },
  {
    q: "What are your hours?",
    a: "Monday through Friday, 9:00 a.m. to 4:00 p.m.; Saturday, 9:00 a.m. to 2:00 p.m. We're closed Sunday. During holiday weeks we're often open later — call ahead and we'll confirm.",
  },
  {
    q: "Is there a satisfaction guarantee?",
    a: "Yes — every arrangement we sell carries our 100% satisfaction guarantee. If something isn't right, call us and we will make it right.",
  },
  {
    q: "Do you sell plants and gifts as well as cut flowers?",
    a: "Yes. The shop carries green and blooming plants, dish gardens, and seasonal gift baskets, along with a walk-in cooler stocked with ready-to-go arrangements, roses, and mixed bouquets.",
  },
];
